import { push } from 'react-router-redux';

const { currentClassRoomId } = require('@core/selectors/classroom');

const navigateToGroupSets = () => (dispatch, getState) => {
  const state = getState();
  const classRoomId = currentClassRoomId(state);
  const url = `/dashboard/${classRoomId}/people/groups/group-sets`;
  dispatch(push(url));
};

export default navigateToGroupSets;
